import integrationGlassGoogleSheets from '@/assets/icons/integrations_glass_google_sheets.png';
import integrationCrmApollo from '@/assets/icons/onboarding_crm_apollo.png';
import integrationCrmAttio from '@/assets/icons/onboarding_crm_attio.png';
import integrationCrmFolk from '@/assets/icons/onboarding_crm_folk.png';
import integrationCrmGoogleSheets from '@/assets/icons/onboarding_crm_google_sheets.png';
import integrationCrmHighLevel from '@/assets/icons/onboarding_crm_highlevel.png';
import integrationCrmHubspot from '@/assets/icons/onboarding_crm_hubspot.png';
import integrationCrmIntercom from '@/assets/icons/onboarding_crm_intercom.png';
import integrationCrmMonday from '@/assets/icons/onboarding_crm_monday.png';
import integrationCrmOdoo from '@/assets/icons/onboarding_crm_odoo.png';
import integrationCrmPipedrive from '@/assets/icons/onboarding_crm_pipedrive.png';
import integrationCrmSalesforce from '@/assets/icons/onboarding_crm_salesforce.png';
import integrationCrmSellsy from '@/assets/icons/onboarding_crm_sellsy.png';
import integrationCrmStreak from '@/assets/icons/onboarding_crm_streak.png';
import integrationCrmZohoCrm from '@/assets/icons/onboarding_crm_zoho.png';
import integrationMake from '@/assets/images/dashboard/make.png';
import integrationNotion from '@/assets/images/dashboard/notion.png';
import integrationCrmShopify from '@/assets/images/dashboard/shopify.png';
import integrationZapier from '@/assets/images/dashboard/zapier.png';
import integrationSplashAttio from '@/assets/images/integrations_splash_attio.png';
import integrationSplashHubspot from '@/assets/images/integrations_splash_hubspot.png';
import integrationSplashOdoo from '@/assets/images/integrations_splash_odoo.png';
import integrationSplashSalesforce from '@/assets/images/integrations_splash_salesforce.png';

import integrationGlassApollo from '@/assets/icons/integrations_glass_apollo.png';
import integrationGlassAttio from '@/assets/icons/integrations_glass_attio.png';
import integrationGlassBrevo from '@/assets/icons/integrations_glass_brevo.png';
import integrationGlassFolk from '@/assets/icons/integrations_glass_folk.png';
import integrationGlassHighLevel from '@/assets/icons/integrations_glass_highlevel.png';
import integrationGlassHubspot from '@/assets/icons/integrations_glass_hubspot.png';
import integrationGlassJobber from '@/assets/icons/integrations_glass_jobber.png';
import integrationGlassMonday from '@/assets/icons/integrations_glass_monday.png';
import integrationGlassNocrm from '@/assets/icons/integrations_glass_nocrm.png';
import integrationGlassOdoo from '@/assets/icons/integrations_glass_odoo.png';
import integrationGlassPipedrive from '@/assets/icons/integrations_glass_pipedrive.png';
import integrationGlassSalesforce from '@/assets/icons/integrations_glass_salesforce.png';
import integrationGlassSellsy from '@/assets/icons/integrations_glass_sellsy.png';
import integrationCrmBrevo from '@/assets/icons/onboarding_crm_brevo.png';
import integrationCrmClaap from '@/assets/icons/onboarding_crm_claap.png';
import integrationCrmClaude from '@/assets/icons/onboarding_crm_claude.png';
import integrationCrmJobber from '@/assets/icons/onboarding_crm_jobber.png';
import integrationCrmNocrm from '@/assets/icons/onboarding_crm_nocrm.png';
import integrationGlassShopify from '@/assets/images/dashboard/shopify.png';

export const SUPPORTED_INTEGRATIONS = [
  'hubspot',
  'attio',
  'salesforce',
  'odoo',
  'pipedrive',
  'shopify',
  'folk',
  'highlevel',
  'zoho_crm',
  'streak',
  'sellsy',
  'apollo',
  'apollo-oauth',
  'jobber',
  'monday',
  'notion',
  'make',
  'zapier',
  'claap',
  'nocrm',
  'google-sheets',
  'intercom',
  'brevo',
  'claude',
] as const;

export type SupportedIntegration = (typeof SUPPORTED_INTEGRATIONS)[number];

/** Normalizes an integration name/type to kebab-case lowercase (e.g. "GOOGLE_SHEETS" → "google-sheets") */
export const normalizeIntegrationName = (s: string) => s.toLowerCase().replace(/_/g, '-');

export type IntegrationStyle = {
  name: SupportedIntegration;
  image: string;
  splash?: string;
  glass?: string;
  chevronHover: string;
  hoverLinearGradient: string;
  hoverBorderColor: string;
  spinnerGradient: string;
  cardGradient: string;
  disabled?: boolean;
  /** When true, this integration is pinned to the top of the unconnected list. */
  featured?: boolean;
  /** Optional pill badge rendered on the integration card. */
  badge?: 'NEW' | 'BETA';
};

export const INTEGRATION_STYLES: IntegrationStyle[] = [
  {
    name: 'claude',
    image: integrationCrmClaude,
    glass: integrationCrmClaude,
    chevronHover: 'group-hover:stroke-[#D97757]',
    hoverLinearGradient: 'from-[#D97757] to-[#F2A88E]',
    hoverBorderColor: '#D97757',
    spinnerGradient: 'to-[#D97757] via-[#F2A88E]',
    cardGradient: 'from-[#D97757] to-[#B85F40]',
    featured: true,
    badge: 'NEW',
  },
  {
    name: 'hubspot',
    image: integrationCrmHubspot,
    splash: integrationSplashHubspot,
    glass: integrationGlassHubspot,
    chevronHover: 'group-hover:stroke-[#FF7A59]',
    hoverLinearGradient: 'from-[#FF7A59] to-[#FFC09F]',
    hoverBorderColor: '#FF7A59',
    spinnerGradient: 'to-[#FF7A59] via-[#FFC09F]',
    cardGradient: 'from-[#FF7959] to-[#FF7A09]',
  },
  {
    name: 'attio',
    image: integrationCrmAttio,
    splash: integrationSplashAttio,
    glass: integrationGlassAttio,
    chevronHover: 'group-hover:stroke-[#565656]',
    hoverLinearGradient: 'from-[#565656] to-[#929292]',
    hoverBorderColor: '#565656',
    spinnerGradient: 'to-[#565656] via-[#929292]',
    cardGradient: 'from-[#000000] to-[#3E3E3E]',
  },
  {
    name: 'salesforce',
    image: integrationCrmSalesforce,
    splash: integrationSplashSalesforce,
    glass: integrationGlassSalesforce,
    chevronHover: 'group-hover:stroke-[#00A1E0]',
    hoverLinearGradient: 'from-[#00A1E0] to-[#32D3FFA1]',
    hoverBorderColor: '#00A1E0',
    spinnerGradient: 'to-[#00A1E0] via-[#32D3FFA1]',
    cardGradient: 'from-[#00A1E0] to-[#47A1E0]',
  },
  {
    name: 'odoo',
    image: integrationCrmOdoo,
    splash: integrationSplashOdoo,
    glass: integrationGlassOdoo,
    chevronHover: 'group-hover:stroke-[#A24689]',
    hoverLinearGradient: 'from-[#A24689] to-[#D478BB]',
    hoverBorderColor: '#A24689',
    spinnerGradient: 'to-[#A24689] via-[#D478BB]',
    cardGradient: 'from-[#47326B] to-[#7A5DA5]',
  },
  {
    name: 'pipedrive',
    image: integrationCrmPipedrive,
    glass: integrationGlassPipedrive,
    chevronHover: 'group-hover:stroke-[#2CA01C]',
    hoverLinearGradient: 'from-[#2CA01C] to-[#54C844]',
    hoverBorderColor: '#2CA01C',
    spinnerGradient: 'to-[#2CA01C] via-[#54C844]',
    cardGradient: 'from-[#017737] to-[#0B7723]',
  },
  {
    name: 'shopify',
    image: integrationCrmShopify,
    glass: integrationGlassShopify,
    chevronHover: 'group-hover:stroke-[#96CEB4]',
    hoverLinearGradient: 'from-[#96CEB4] to-[#B4E198]',
    hoverBorderColor: '#96CEB4',
    spinnerGradient: 'to-[#96CEB4] via-[#B4E198]',
    cardGradient: 'from-[#00758F] to-[#00A1C6]',
  },
  {
    name: 'folk',
    image: integrationCrmFolk,
    glass: integrationGlassFolk,
    chevronHover: 'group-hover:stroke-[#565656]',
    hoverLinearGradient: 'from-[#565656] to-[#929292]',
    hoverBorderColor: '#565656',
    spinnerGradient: 'to-[#565656] via-[#929292]',
    cardGradient: 'from-[#3E3E3E] to-[#6B7280]',
  },
  {
    name: 'zoho_crm',
    image: integrationCrmZohoCrm,
    glass: integrationCrmZohoCrm,
    chevronHover: 'group-hover:stroke-[#2C5AA0]',
    hoverLinearGradient: 'from-[#2C5AA0] to-[#4A7BC8]',
    hoverBorderColor: '#2C5AA0',
    spinnerGradient: 'to-[#2C5AA0] via-[#4A7BC8]',
    cardGradient: 'from-[#2C5AA0] to-[#4A7BC8]',
  },
  {
    name: 'streak',
    image: integrationCrmStreak,
    glass: integrationCrmStreak,
    chevronHover: 'group-hover:stroke-[#F04C00]',
    hoverLinearGradient: 'from-[#FF9805] to-[#F74C55]',
    hoverBorderColor: '#FF9805',
    spinnerGradient: 'to-[#F74C55] via-[#FF9805]',
    cardGradient: 'from-[#FF9805] to-[#F74C55]',
  },
  {
    name: 'sellsy',
    image: integrationCrmSellsy,
    glass: integrationGlassSellsy,
    chevronHover: 'group-hover:stroke-[#1E3A8A]',
    hoverLinearGradient: 'from-[#1E3A8A] to-[#3B82F6]',
    hoverBorderColor: '#1E3A8A',
    spinnerGradient: 'to-[#1E3A8A] via-[#3B82F6]',
    cardGradient: 'from-[#1E40AF] to-[#2563EB]',
  },
  {
    name: 'highlevel',
    image: integrationCrmHighLevel,
    glass: integrationGlassHighLevel,
    chevronHover: 'group-hover:stroke-[#10B981]',
    hoverLinearGradient: 'from-[#10B981] to-[#34D399]',
    hoverBorderColor: '#10B981',
    spinnerGradient: 'to-[#10B981] via-[#34D399]',
    cardGradient: 'from-[#059669] to-[#10B981]',
  },
  // {
  //   name: 'apollo',
  //   image: integrationCrmApollo,
  //   glass: integrationGlassApollo,
  //   chevronHover: 'group-hover:stroke-[#565656]',
  //   hoverLinearGradient: 'from-[#565656] to-[#929292]',
  //   spinnerGradient: 'to-[#565656] via-[#929292]',
  //   cardGradient: 'from-[#000000] to-[#3E3E3E]',
  // },
  {
    name: 'apollo-oauth',
    image: integrationCrmApollo,
    glass: integrationGlassApollo,
    chevronHover: 'group-hover:stroke-[#565656]',
    hoverLinearGradient: 'from-[#565656] to-[#929292]',
    hoverBorderColor: '#565656',
    spinnerGradient: 'to-[#565656] via-[#929292]',
    cardGradient: 'from-[#000000] to-[#3E3E3E]',
  },
  {
    name: 'jobber',
    image: integrationCrmJobber,
    glass: integrationGlassJobber,
    chevronHover: 'group-hover:stroke-[#4B5563]',
    hoverLinearGradient: 'from-[#4B5563] to-[#9CA3AF]',
    hoverBorderColor: '#4B5563',
    spinnerGradient: 'to-[#4B5563] via-[#9CA3AF]',
    cardGradient: 'from-[#52575F] to-[#7D8490]',
  },
  {
    name: 'monday',
    image: integrationCrmMonday,
    glass: integrationGlassMonday,
    chevronHover: 'group-hover:stroke-[#6161FF]',
    hoverLinearGradient: 'from-[#6161FF] to-[#A25DDC]',
    hoverBorderColor: '#6161FF',
    spinnerGradient: 'to-[#6161FF] via-[#A25DDC]',
    cardGradient: 'from-[#6161FF] to-[#7B5FC7]',
  },
  {
    name: 'notion',
    image: integrationNotion,
    glass: integrationNotion,
    chevronHover: 'group-hover:stroke-[#191919]',
    hoverLinearGradient: 'from-[#191919] to-[#525252]',
    hoverBorderColor: '#191919',
    spinnerGradient: 'to-[#191919] via-[#525252]',
    cardGradient: 'from-[#191919] to-[#3E3E3E]',
  },
  {
    name: 'zapier',
    image: integrationZapier,
    glass: integrationZapier,
    chevronHover: 'group-hover:stroke-[#CC3F00]',
    hoverLinearGradient: 'from-[#CC3F00] to-[#E56A2B]',
    hoverBorderColor: '#CC3F00',
    spinnerGradient: 'to-[#CC3F00] via-[#E56A2B]',
    cardGradient: 'from-[#B33700] to-[#CC3F00]',
  },
  {
    name: 'make',
    image: integrationMake,
    glass: integrationMake,
    chevronHover: 'group-hover:stroke-[#CC007B]',
    hoverLinearGradient: 'from-[#CC007B] to-[#E5408F]',
    hoverBorderColor: '#CC007B',
    spinnerGradient: 'to-[#CC007B] via-[#E5408F]',
    cardGradient: 'from-[#B3006D] to-[#CC007B]',
  },
  {
    name: 'claap',
    image: integrationCrmClaap,
    glass: integrationCrmClaap,
    chevronHover: 'group-hover:stroke-[#252a44]',
    hoverLinearGradient: 'from-[#252a44] to-[#3d4566]',
    hoverBorderColor: '#252a44',
    spinnerGradient: 'to-[#252a44] via-[#3d4566]',
    cardGradient: 'from-[#252a44] to-[#3d4566]',
  },
  {
    name: 'google-sheets',
    image: integrationCrmGoogleSheets,
    glass: integrationGlassGoogleSheets,
    chevronHover: 'group-hover:stroke-[#34A853]',
    hoverLinearGradient: 'from-[#34A853] to-[#4CAF50]',
    hoverBorderColor: '#34A853',
    spinnerGradient: 'to-[#34A853] via-[#4CAF50]',
    cardGradient: 'from-[#0A5C32] to-[#0F8040]',
  },
  {
    name: 'nocrm',
    image: integrationCrmNocrm,
    glass: integrationGlassNocrm,
    chevronHover: 'group-hover:stroke-[#1B84E2]',
    hoverLinearGradient: 'from-[#1B84E2] to-[#4BA2EE]',
    hoverBorderColor: '#1B84E2',
    spinnerGradient: 'to-[#1B84E2] via-[#4BA2EE]',
    cardGradient: 'from-[#1B84E2] to-[#3A96ED]',
  },
  {
    name: 'intercom',
    image: integrationCrmIntercom,
    glass: integrationCrmIntercom,
    chevronHover: 'group-hover:stroke-[#1F8FE7]',
    hoverLinearGradient: 'from-[#1F8FE7] to-[#5FAFE9]',
    hoverBorderColor: '#1F8FE7',
    spinnerGradient: 'to-[#1F8FE7] via-[#5FAFE9]',
    cardGradient: 'from-[#1F8FE7] to-[#4BA3E8]',
  },
  {
    name: 'brevo',
    image: integrationCrmBrevo,
    glass: integrationGlassBrevo,
    chevronHover: 'group-hover:stroke-[#0B996B]',
    hoverLinearGradient: 'from-[#0B996B] to-[#3DBD8E]',
    hoverBorderColor: '#0B996B',
    spinnerGradient: 'to-[#0B996B] via-[#3DBD8E]',
    cardGradient: 'from-[#087A55] to-[#0B996B]',
  },
  // {
  //   name: "quickbooks",
  //   image: integrationCrmQuickbooks,
  //   splash: integrationSplashQuickbooks,
  //   chevronHover: "group-hover:stroke-[#2CA01C]",
  //   hoverLinearGradient: "from-[#2CA01C] to-[#54C844]",
  // },
];
